<template>
	<div>
		<el-card shadow="never">
			<div>
				<el-form size="small" :inline="true" label-position="right" label-width="120px" :rules="rules" :model="formData">
					<el-form-item label="开始日期" prop="beginTime">
						<el-date-picker
							size="small"
							style="width: 250px"
							v-model="formData.beginTime"
                            value-format="yyyy-MM-dd HH:mm:ss"
							type="date"
							placeholder="选择开始日期"
						>
						</el-date-picker>
					</el-form-item>
					<el-form-item label="结束日期" prop="endTime">
						<el-date-picker
							size="small"
							style="width: 250px"
							v-model="formData.endTime"
                            value-format="yyyy-MM-dd HH:mm:ss"
							type="date"
							placeholder="选择结束日期"
						>
						</el-date-picker>
					</el-form-item>
				</el-form>
			</div>
			<div class="form-buttons-center">
				<el-button size="small" type="primary" :loading="saveLoading" @click="doSave">保存</el-button>
				<el-button size="small" @click="doClose">关闭</el-button>
			</div>
		</el-card>
	</div>
</template>
<script>
import dlgForm from "@/mixin/dlgForm";

export default {
	name: "ModifyValidDateForm",
	mixins: [dlgForm],
	data() {
		return {
			rules: {
				beginTime: [{ required: true, message: "请输入开始日期", trigger: "blur" }],
                endTime: [{ required: true, message: "请输入结束日期", trigger: "blur" }]
			},
		};
	},
	methods: {
		doSave() {
            const url = 'car/web/carManage/card/editDate';
            this._doSaveForm(this.$refs.form, url, 'POST');
		},
	},
};
</script>
